export const REFERRAL_STORAGE_KEY = "cryptember.pendingReferralCode";
export const REFERRAL_PATTERN = /^ur[A-Za-z0-9]{7}$/;

export function captureReferralFromLocation(location = window.location) {
  const code = new URLSearchParams(location.search).get("ref");
  if (REFERRAL_PATTERN.test(code || "")) { sessionStorage.setItem(REFERRAL_STORAGE_KEY, code); return code; }
  if (code != null) sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  return null;
}

export function pendingReferralCode() {
  const value = sessionStorage.getItem(REFERRAL_STORAGE_KEY);
  return REFERRAL_PATTERN.test(value || "") ? value : null;
}

export function clearPendingReferral() { sessionStorage.removeItem(REFERRAL_STORAGE_KEY); }

export function cleanAuthAndReferralParams(input = window.location.href) {
  const url = new URL(input, window.location.origin);
  ["id", "first_name", "last_name", "username", "photo_url", "auth_date", "hash", "t", "ref"]
    .forEach((name) => url.searchParams.delete(name));
  return url;
}
